import React from 'react'

import ProjectUserFull from "../../../../../../model2/project-user/project-user-full"
import FieldView from "../../../../../../fields3/render/view"
import {UserInheritance} from "../../../../../../gd/const/project"
import Team from "../../../../../../model2/team/team"

type Props = {
    projectUser     : ProjectUserFull
}

// const debug = "ModalUser_InheritanceNotification"
const debug = false

export default function ModalUser_InheritanceNotification(props: Props) {

    if (!props.projectUser.inheritance) return null

    switch (props.projectUser.inheritance) {
        case UserInheritance.INHERITED_TEAM:
            const message = props.projectUser.teams.length === 1 ? "This user is a part of a team" : "This user is a part of a teams"
            return (
                <div className="ui5-notification notification-inline m-b-15">
                    <div className="message fl-ac">
                        <div className="flex-row-left-center">
                            <div className="icon ui5-ico-13 i5-users m-r-10"/>
                        </div>
                        <div className="text flex-row-left-center flex-wrap">
                            {message}
                            {_.map(props.projectUser.teams, (team: Team) => {
                                return (
                                    <div key={team.id} className="ui5-property max-w-200 m-l-5 m-b-3 m-t-3">
                                        {team.name}
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            )
            break

        default:
            const inheritedFromProject = props.projectUser.inheritedFromProject

            const onInheritedAccessClick = () => {
                debug && console.log(debug, 'onInheritedAccessClick')
                if (inheritedFromProject.acl.hasClientAccess) {
                    inheritedFromProject.goTo()
                }
            }

            const inheritanceClasses = Classes('m-l-5 m-r-5', {
                'ui5-txt-link': inheritedFromProject.acl.hasClientAccess && !inheritedFromProject.isWorkspace
            })

            return (
                <div className="ui5-notification notification-inline m-b-15">
                    <div className="message fl-ac">
                        <div className="icon ui5-ico-13 i5-inherited m-r-10"/>
                        <div className="text flex-row">
                            This user is inherited from
                            <span className = {inheritanceClasses}
                                  onClick   = {onInheritedAccessClick}>
                        <div className="flex-row-left-center">
                            <FieldView className    = "m-r-5"
                                       field        = {gd.fields.project.projectIcon}
                                       model        = {inheritedFromProject}/>
                            {inheritedFromProject.name}
                        </div>
                    </span>
                        </div>
                    </div>
                </div>
            )
    }
}
